/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-05-20 10:34:56
 * @LastEditors: yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-06-06 15:51:38
 * @FilePath: \MPC-monorepo\features\mpc-common\src\utils\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export { default as ajax } from './ajax';
export { default as axios } from './axios';
export { default as scout } from './scout';
export * from './MPCJsonLogic';
export * from './router';
export * from './versionMonitor';
export * from './sType';
export * from './v1Router';
export { default as showAlertDebounce } from './showAlert';
export * from './scrollUtils';

export const defaultRootFontSize = 1;

/**
 * 将nember转换为xxrem，其他类型不做处理
 * @param px
 * @returns
 */
export const localPx2rem = (px?: number | string) => {
  // 如果传入的不是数字，则不做处理
  if (typeof px === 'number' && !isNaN(px))
    return px / defaultRootFontSize + 'rem';
  return px;
};

export const tableColumnWidthToRem = (item: { width?: number | string }) => {
  if (typeof item?.width === 'number') {
    item.width = localPx2rem(item.width);
  }
  return item;
};

export const stylePx2Rem = (item: { width?: number | string }) => {
  if (typeof item?.width === 'number') {
    item.width = localPx2rem(item.width);
  }
  return item;
};

export const getRootElementFontSize = () => {
  const fontSize = document.documentElement.style.fontSize;
  if (fontSize === undefined || fontSize === '') {
    return defaultRootFontSize;
  }
  if (fontSize.indexOf('px') !== -1) {
    return Number(fontSize.replace('px', ''));
  }
  return fontSize;
};

// 多层递归处理
export function flatByChildrenKey(trees: any[], childrenKey: string) {
  if (!trees?.length) return [];
  const result = [];
  for (const tree of trees) {
    result.push(tree);
    if (tree[childrenKey]?.length) {
      result.push(...flatByChildrenKey(tree[childrenKey], childrenKey));
    }
  }
  return result;
}
